module.exports = __webpack_public_path__ + "media/fonts/BasisGrotesquePro-MediumItalic-b68dc6a8d9e6a68459f43b2f213fe17b.woff2";